/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */

export type TopUpFeeCalculationBase = typeof TopUpFeeCalculationBase[keyof typeof TopUpFeeCalculationBase];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TopUpFeeCalculationBase = {
  TOTAL_LOAN_AMOUNT: 'TOTAL_LOAN_AMOUNT',
  ADDITIONAL_AMOUNT_ONLY: 'ADDITIONAL_AMOUNT_ONLY',
} as const;

